export default "__VITE_ASSET__GpZVJVBd__"